import React from 'react';
import { Badge, Dropdown } from '@bynder/design-system';

import { MenuItem } from '../../types';

/*
 * bynder-platform/bynder/views/navigation/includes/menu.cfm
 */
export function AccountMenuItem({ item }: { item: MenuItem }) {
	const Icon = item.icon;

	if (!item.isVisible) {
		return null;
	}

	if (item.Component) {
		const Component = item.Component;

		return <Component />;
	}

	if (item.type === 'header') {
		return <Dropdown.SectionTitle>{item.label}</Dropdown.SectionTitle>;
	}

	if (item.type === 'divider') {
		return <Dropdown.Divider />;
	}

	return (
		<Dropdown.Item
			{...(item.menuItems
				? {
						submenu: (
							<>
								{item.menuItems.map((menuItem) => {
									return <AccountMenuItem item={menuItem} key={menuItem.key} />;
								})}
							</>
						),
				  }
				: {
						href: item.href || '',
						target: item.target || '_self',
				  })}
			icon={Icon ? <Icon /> : undefined}
			badge={item.badgeLabel ? <Badge isPillShaped>{item.badgeLabel}</Badge> : undefined}
		>
			{item.label}
		</Dropdown.Item>
	);
}
